exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".help-question-url{display:flex;align-items:center;margin:0 -10px}.help-question .icon{margin:0 10px}.help-question span{margin:0 10px;display:block;flex:1 0 0}", ""]);
